var map = {
	"./calendar.png": "a25e",
	"./challenge_fail.png": "d43c",
	"./challenge_success.png": "f8b5",
	"./check.png": "322e",
	"./dialog_fail.png": "3443",
	"./dialog_success.png": "25a4",
	"./download.png": "5d5d",
	"./download_pdf.png": "20d0",
	"./history.png": "d3b1",
	"./history_hover.png": "bc55",
	"./info.png": "2e99",
	"./label_icon.png": "69ff",
	"./lock.png": "969e",
	"./lock_hover.png": "1860",
	"./national_flag.png": "fe89",
	"./no_account.png": "6ac1",
	"./payout.png": "62a2",
	"./payout_hover.png": "96f4",
	"./prop-trade-header-bg1.png": "f985",
	"./prop-trade-header-bg2.png": "e099",
	"./prop-trade-header-bg3.png": "45f2",
	"./prop-trade-header-point1.png": "fac8",
	"./prop-trade-header-point2.png": "1128",
	"./prop-trade-header-point3.png": "94ab",
	"./prop-trading-banner-arrow.png": "824e",
	"./prop-trading-banner-arrow3.png": "25bc",
	"./prop-trading-banner-mid.png": "1a1e",
	"./prop-trading-banner-mobile.png": "419e",
	"./prop-trading-banner-step1.png": "68f4",
	"./prop-trading-banner-step2.png": "d3e2",
	"./prop-trading-banner-step3.png": "c0ea",
	"./prop-trading-banner.png": "0178",
	"./prop-trading-logo.png": "8505",
	"./prop-trading-step-banner-mid.png": "ca68",
	"./prop-trading-step-banner-mobile.png": "c816",
	"./prop-trading-step-banner.png": "0012",
	"./reset-pwd-info.png": "e26b",
	"./setting.png": "1382",
	"./setting_hover.png": "9b3e",
	"./trade_check.png": "b5ea",
	"./trade_fail.png": "98ff",
	"./trade_info.png": "e104",
	"./trade_processing.png": "bfb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf4e";